  <template>
  <div id="usercontainer">
    <spinner v-if="this.userinfo==null"></spinner>      
    <div v-else-if="this.userinfo!= null">        
       
       <div class="buttoncontainer">

        <button class="cbutton" type="button" @click="takeControl(userinfo.id);" :disabled="havecontrol">
            <font-awesome-icon icon="user" />  Prendi il controllo
        </button>

        <button class="cbutton" type="button" @click="leaveControl(userinfo.id);" :disabled="!havecontrol">
            <font-awesome-icon icon="robot" />  Lascia al bot
        </button>      
       </div>
                
        <div class="userinfo" :key="userinfo.id" >
            <!--<img :src="userinfo.avatar" class="avatar" :alt="userinfo.name">  -->
            <vue-letter-avatar class="avatar" v-if="userinfo.avatar==null" :name="userinfo.first_name" size='96' :rounded=true />
            <!-- <avatar fullname="Foo Bar" :size="60"></avatar> -->                
            <img  v-else-if="userinfo.avatar==null" :src="userinfo.avatar" class="avatar" :title="`${userinfo.first_name + ` ` + userinfo.last_name}`">      

            <h6><b>Nome:</b> {{userinfo.first_name}}</h6>  
            <h6><b>Cognome:</b> {{userinfo.last_name}}</h6>  
            <h6><b>Piattaforma:</b> {{userinfo.platform}}</h6>  
            <h6 v-if="userinfo.email"><b>Email:</b> {{userinfo.email}}</h6>  
            <h6 v-if="userinfo.phone"><b>Telefono:</b> {{userinfo.phone}}</h6>              

            <div v-if="userinfo.address">
              <h6><b>Indirizzo:</b> {{userinfo.address.street}} - {{userinfo.address.zipcode}} {{userinfo.address.city}}</h6>                           

              <GmapMap v-if="userinfo.address.geo" :options="{zoomControl: true,mapTypeControl: false,scaleControl: false,streetViewControl: false,rotateControl: false,fullscreenControl: true,disableDefaultUi: false}"  :center="center" :zoom="16"  style="width: 100%; height: 300px">
                  <gmap-marker :title="userinfo.address.street" :position="{lat: userinfo.address.geo.lat, lng: userinfo.address.geo.lng}">                    
                  </gmap-marker>
              </GmapMap>
            </div>

        </div>    
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

import VueLetterAvatar from 'vue-letter-avatar';
Vue.use(VueLetterAvatar);

import UserDetailsRepository from './../../repositories/UserDetailsRepository';
import spinner from './../../components/CustomLoader'


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBD-wGKKT3dIDoDPE8Tc9XdxrOgYZM0QFU'    
    // To use the Google Maps JavaScript API, you must register your app project on the Google API Console and get a Google API key which you can add to your app
    // v: 'OPTIONAL VERSION NUMBER',
    // libraries: 'places', //// If you need to use place input
  },
    installComponents: true
})
export default {
  name: "usercontainer",  
  mixins: [UserDetailsRepository], 
  components: {    
    spinner
  },
  data() {
    return {
      userinfo:null,
      ConversationId:0,  
      ProjectID:0,    
      isLoading:true,
      center: {},   
      havecontrol:false               
    };
    
  }       
};
</script>
<style>
.buttoncontainer{
    margin: 0 auto;
    width: 100%;
    float: left;
    text-align: center;
}
.userinfo{
    padding: 10px;
}

.userinfo .avatar{
    border-radius: 50%;
    width: 100px;
    height: 100px;
    margin: 0 auto;
    display: block;
    margin: 10px auto;
}
</style>

